// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorSubmission_wrapper__k6VaE"};